import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "blockquote my-4 bg-white shadow-sm" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "mt-3 ms-3 quote-icon fas fa-quote-left fa-lg text-primary" }, null, -1)
const _hoisted_3 = { class: "px-5 pb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("blockquote", _hoisted_1, [
    _hoisted_2,
    _createVNode("p", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}